import Header from "../../components/Header/Header";
import { MdError } from "react-icons/md";
import Button from "../../components/Buttons/Button";
import useRegisterLost from "#features/LostFound/hooks/useRegisterLost";
import { CiCalendarDate } from "react-icons/ci";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ko } from "date-fns/locale";
import { forwardRef } from "react";

import { FaCheck } from "react-icons/fa";
import SelectBranch from "../../components/SelectBranch/SelectBranch";
import useReactGASend from "../../hooks/useReactGASend";
import useSelectBrand from "#hooks/styles/useSelectBrand";

const CustomInput = forwardRef(({ value, onClick }, ref) => (
  <button
    className="relative flex items-center justify-between w-full font-medium bg-no-repeat rounded-lg input bg-neutral-100"
    onClick={onClick}
  >
    {value}

    <CiCalendarDate className="text-3xl text-neutral-500" />
  </button>
));

const RegistLostItemPage = () => {
  const {
    handleChange,
    handleDateChange,
    formData,
    showError,
    submit,
    loading,
    isFormLink,
    branchList,
    selectBranch,
    selectedBranchId,
  } = useRegisterLost();
  const { color } = useSelectBrand();

  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };
  return (
    <section className="p-hasHeader">
      <Header title="분실물 등록" />

      {/* 점포가 없는 경우 (외부링크대응) */}
      {isFormLink.isFormLink ? (
        <label className="form-control w-full mt-2.5">
          <div className="label">
            <span className="flex items-center gap-2 text-base font-semibold label-text">
              <FaCheck className={`text-${color}`} />
              점포
            </span>
          </div>
          <div className="flex items-center gap-1.5">
            <SelectBranch
              branchList={branchList}
              selectBranch={selectBranch}
              storeId={selectedBranchId}
              color={color}
            />
          </div>
        </label>
      ) : (
        <label className="form-control w-full mt-2.5">
          <div className="label">
            <span className="flex items-center gap-2 text-base font-semibold label-text">
              <FaCheck className={`text-${color}`} /> 점포
            </span>
          </div>
          <div className="flex items-center gap-1.5">
            <input
              type="text"
              name="contact"
              className="w-full font-medium rounded-lg input bg-neutral-100"
              value={formData.branchName}
              autoComplete="off"
              readOnly
            />
          </div>
        </label>
      )}

      <label className="form-control w-full mt-2.5">
        <div className="label">
          <span className="flex items-center gap-2 text-base font-semibold label-text">
            <FaCheck className={`text-${color}`} /> 이름
          </span>
        </div>
        <div className="flex items-center gap-1.5">
          <input
            type="text"
            name="name"
            placeholder="이름을 입력하세요"
            className="w-full font-medium rounded-lg input bg-neutral-100"
            value={formData.name}
            onChange={(e) => handleChange(e)}
            autoComplete="off"
          />
        </div>
        {showError.name && (
          <div className="label">
            <span className="text-sm text-red-500 label-text-alt">
              필수입력 사항입니다.
            </span>
          </div>
        )}
      </label>

      <div className="form-control w-full mt-2.5">
        <div className="label">
          <span className="flex items-center gap-2 text-base font-semibold label-text">
            <FaCheck className={`text-${color}`} /> 분실일자
          </span>
        </div>
        <div className="relative flex items-center gap-1.5">
          <DatePicker
            selected={formData.lostDate}
            name="lostDate"
            onChange={(date) => handleDateChange(date, "lostDate")}
            dateFormat="yyyy-MM-dd"
            customInput={<CustomInput />}
            locale={ko}
            maxDate={formData.maxDate}
            minDate={formData.minDate}
            shouldCloseOnSelect
          />
        </div>
        {showError.lostDate && (
          <div className="label">
            <span className="text-sm text-red-500 label-text-alt">
              필수입력 사항입니다.
            </span>
          </div>
        )}
      </div>

      <label className="form-control w-full mt-2.5">
        <div className="label">
          <span className="flex items-center gap-2 text-base font-semibold label-text">
            <FaCheck className={`text-${color}`} /> 연락처
          </span>
        </div>
        <div className="flex items-center gap-1.5">
          <input
            type="tel"
            name="phoneNumber"
            className="w-full font-medium rounded-lg input bg-neutral-100"
            value={formData.phoneNumber}
            autoComplete="off"
            onChange={
              isFormLink.isFormLink ? (e) => handleChange(e) : undefined
            }
            readOnly={!isFormLink.isFormLink}
          />
        </div>
        {showError.phoneNumber && (
          <div className="label">
            <span className="text-sm text-red-500 label-text-alt">
              필수입력 사항입니다. (입력예: 01012345678)
            </span>
          </div>
        )}
      </label>

      <label className="form-control w-full mt-2.5">
        <div className="label">
          <span className="flex items-center gap-2 text-base font-semibold label-text">
            <FaCheck className={`text-${color}`} /> 분실장소
          </span>
        </div>
        <div className="flex items-center gap-1.5">
          <input
            name="lostLocation"
            type="text"
            placeholder="예시) 2번 계산대, 자율포장대 등"
            className="w-full font-medium rounded-lg input bg-neutral-100"
            value={formData.lostLocation}
            onChange={(e) => handleChange(e)}
            autoComplete="off"
          />
        </div>
        {showError.lostLocation && (
          <div className="label">
            <span className="text-sm text-red-500 label-text-alt">
              필수입력 사항입니다.
            </span>
          </div>
        )}
      </label>

      <label className="form-control mt-2.5">
        <div className="label">
          <span className="flex items-center gap-2 text-base font-semibold label-text">
            <FaCheck className={`text-${color}`} /> 분실물품
          </span>
        </div>
        <textarea
          className="text-base font-medium rounded-lg textarea h-28 bg-neutral-100"
          placeholder="예시) 제품명, 브랜드, 색상 및 상세정보 기재"
          name="lostItemDetails"
          onChange={(e) => handleChange(e)}
        ></textarea>
        {showError.lostItemDetails && (
          <div className="label">
            <span className="text-sm text-red-500 label-text-alt">
              필수입력 사항입니다.
            </span>
          </div>
        )}
      </label>

      <p className="flex gap-2 my-3 p-3.5 text-stone-700 bg-slate-50 rounded-[20px] border border-violet-50 break-keep font-medium">
        <span>
          <MdError style={{ color: "#4C3D38 " }} />
        </span>
        분실물 정보를 정확히 입력해주세요. <br />
        물품 미습득 시 별도 연락은 드리지 않습니다.
      </p>

      <div className="mt-10">
        <Button
          onClick={
            !loading
              ? () => {
                  submit();
                  trackButtonClick("분실물등록");
                }
              : null
          }
        >
          {loading ? (
            <span className="loading loading-dots loading-lg"></span>
          ) : (
            "등록"
          )}
        </Button>
      </div>
    </section>
  );
};

export default RegistLostItemPage;
